<template>
  <div class="box-title pr-10 clearfix">
    <div class="fl">{{title}}</div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '列表'
    }
  }
}
</script>

<style>

</style>
